export default "__VITE_ASSET__cbe1bf5f__"